module.exports = __webpack_public_path__ + "img/shipping.53315a4b.svg";